import { Theme } from '@mui/material/styles';
import deepmerge from '@mui/utils/deepmerge';

import { Brand } from '@newfold/tokens';

import { PaletteMode, ThemeByMode } from '../../themeDefault';
import { createAlertTheme } from '../v2/components/Alert';
import { createButtonTheme, createLinkTheme } from '../v2/components/Button';
import { createCardContentTheme } from '../v2/components/Card';
import { createRevampComponentOverrides } from './bluehost';

const hostgatorThemeOverrides = (theme: Theme) => {
  const hostgatorButtonTheme = createButtonTheme(theme) ?? {};
  const hostgatorLinkTheme = createLinkTheme(theme) ?? {};

  return {
    components: {
      MuiButton: {
        ...hostgatorButtonTheme,
        styleOverrides: deepmerge(hostgatorButtonTheme.styleOverrides, {
          root: {
            '&.MuiButton-text': {
              color: theme.palette.primary.main,
              ':hover': {
                color: theme.palette.primary.dark,
              },
            },
          },
        }),
      },
      MuiLink: deepmerge(hostgatorLinkTheme, {
        styleOverrides: {
          root: {
            color: theme.palette.primary.main,
            ':hover': {
              color: theme.palette.primary.dark,
            },
          },
        },
      }),

      MuiAlert: createAlertTheme(theme, 'dark'),
      MuiCardContent: createCardContentTheme(theme, 'primary'),
    },
  };
};

export const hostgatorGlobalStyles = {};

/**
 * HostGator redesign: shared revamp components with legacy HG palette and typography.
 */
export const createHostgatorRevampTheme = (
  mode: PaletteMode = 'light',
  brand: Brand,
): Theme => {
  const theme = ThemeByMode(mode, brand);
  const bluehostRevampComponents = createRevampComponentOverrides(theme);
  const hostgatorOverrides = hostgatorThemeOverrides(theme);

  return deepmerge(theme, {
    components: {
      ...bluehostRevampComponents,
      ...hostgatorOverrides.components,
    },
  });
};

export const getHostgatorRevampGlobalStyles = (_selector: string) =>
  hostgatorGlobalStyles;
